import React from 'react'

import { Route, Routes } from 'react-router-dom'

import PropTypes from 'prop-types'

import PageLayout from 'Pods/Layout/PageLayout'
import ContextBasedRouter from 'Pods/Shared/ContextBasedRouter'

import EventPage from './EventPage'
import EventsList from './EventsList'

function EventsLayout({
  navigation, footer, navClass, navId, layout,
}) {
  return (
    <ContextBasedRouter initialPathname={navigation.currentPathname}>
      <Routes>
        <Route
          path="/events"
          element={(
            <PageLayout
              component={EventsList}
              navigation={navigation}
              footer={footer}
              navClass={navClass}
              navId={navId}
              data={layout.data}
            />
          )}
        />
        <Route
          path="/events/:id"
          element={(
            <PageLayout
              component={EventPage}
              navigation={navigation}
              footer={footer}
              navClass={navClass}
              navId={navId}
              data={layout.data}
              included={layout.included}
              ecommerceNews={layout.ecommerceNewsData}
            />
          )}
        />
      </Routes>
    </ContextBasedRouter>
  )
}

EventsLayout.propTypes = {
  layout: PropTypes.shape({
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  }).isRequired,
}

export default EventsLayout
